<!------------------------------------------------------------------------------
  Copyright (c) 2019. Keni Williams <kenneth.williams@estuk.co.uk>

  This file CheckoutNewCardDetails.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  CheckoutNewCardDetails.vue can not be copied and/or distributed
  without the express permission of Keni Williams <kenneth.williams@estuk.co.uk>
  ----------------------------------------------------------------------------->

<template>
    <div class="card-body container">
        <div class="mb-2">
            <h5 class="mb-0 h5 d-flex align-items-center">
                <i class="material-icons pr-1" aria-hidden="true">credit_card</i>
                <strong v-if="step !== null" class="mr-1"> {{step}}:</strong> <span>
                <bold-words :word="{
                        text:text
                        }"
                /></span>
            </h5>
            <small class="text-muted d-block">{{msg}}</small>
        </div>

        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "checkout-new-card-details",
        props: {
            step: {
                type: Number,
                default: 2
            },
            text:{
                type: String,
                default: 'Card details'
            },
            msg:{
                type:String,
                default:'Once your email address is complete, card details will open'
            },
            devMode: {
                type: Boolean,
                default: false
            },
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/checkout/CheckoutNewCardDetails.vue